'use strict';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {CurationActionCreatorService} from '../../../services/curation-action-creator.service';
import {DynamicModalLoaderService} from '../../../../layout/services/dynamic-modal-loader.service';
import {CurationEditorHelper} from '../curation-editor-helper';
import {FormHandlerService} from '@ispm/dynamic-form/services/form-handler.service';
import {WorkflowBarActionsCreatorService} from '../../../../shared/components/workflow-bar/services/workflow-bar-actions-creator.service';
import {CurationEvidenceBuilder} from '../../../classes/curation-evidence';
import {CurationEditorAbstract} from '../curation-editor-abstract';
import * as _ from 'lodash';
import {ICurationUpdateRequest} from '../../../interfaces/curation-update-request.interface';
import {CurationUtils} from '../../../utils/curation-utils';
import {CurationSettings} from '../../curation-dashboard/curation-setting';
import {PanelsService} from "@ispm/layout/services/panels.service";
import {CoreActionCreatorService} from "@ispm/core/services/core-action-creator.service";
import {TranslateService} from "@ngx-translate/core";
import {UserActionCreatorService} from '@ispm/user/services/user-action-creator.service';
import {DiagnosticOrderService} from '@ispm/dashboard/test/services/diagnostic-order.service';
import {ActivityService} from '@ispm/user/services/activity.service';
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {NotesService} from '@ispm/user/services/notes.service';
import {NotificationMessageService} from '@ispm/core/components/customise-notification/notifications-message.service';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

const SEARCH_DATA_PREFIX = 'searchParameters_';

@Component({
  selector: 'gen-curation-editor-aberration',
  templateUrl: 'curation-editor-aberration.component.html',
  styleUrls: ['curation-editor-aberration.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class CurationEditorAberrationComponent extends CurationEditorAbstract {
  private searchGeneralConfigParams: any;
  public aberrationDetailsFormName: string;
  public evidence: any = { };
  public diagnosticFormName: string;
  public prognosticFormName: string;
  public therapeuticFormName: string;
  public clinicalTrialsFormName: string;
  public casesFormName: string;
  public summaryFormName: string;
  public pubmedFormName: string;
  public aberrationDataVerticalForm: boolean = true; // All forms are vertical by default (Fusion form for example is a non vertical form)
  public searchDataConfigParams: any;
  public searchFormConfigParams: any;
  public googleSearchURL: string;
  public pubmedSearchURL: string;
  @Input() curationDataForSearch: { [key: string]: string; } = { };

  constructor(authService: AuthenticationService,
              formHandler: FormHandlerService,
              public notificationMessageService: NotificationMessageService,
              workflowBarActionsCreatorService: WorkflowBarActionsCreatorService,
              modalLoader: DynamicModalLoaderService,
              activatedRoute: ActivatedRoute,
              panelService: PanelsService,
              curationActionCreatorService: CurationActionCreatorService,
              notesService: NotesService,
              coreAC: CoreActionCreatorService,
              translateService: TranslateService,
              protected diagnosticOrderService : DiagnosticOrderService,
              detector: ChangeDetectorRef,
              public userActionCreatorService: UserActionCreatorService,
              public activityService: ActivityService,
              workflowConfigService: WorkflowConfigService,
              _http: HttpInterceptorService,
              router: Router,
              routerManagerService: RouterManagerService) {
    super(authService, formHandler, notificationMessageService, workflowBarActionsCreatorService, modalLoader,
          activatedRoute, panelService, notesService, coreAC, curationActionCreatorService, translateService,
          diagnosticOrderService, userActionCreatorService, activityService, _http, router, undefined, detector, workflowConfigService, routerManagerService);
  }

  setInitParams() { }

  postUpdateCurationItem() { }

  loadFormNames() {
    if (this.editorFormsMap['CLINICAL_SIGNIFICANCE_DIAGNOSTIC']) { this.diagnosticFormName = this.editorFormsMap['CLINICAL_SIGNIFICANCE_DIAGNOSTIC'].name; }
    if (this.editorFormsMap['CLINICAL_SIGNIFICANCE_PROGNOSTIC']) { this.prognosticFormName = this.editorFormsMap['CLINICAL_SIGNIFICANCE_PROGNOSTIC'].name; }
    if (this.editorFormsMap['CLINICAL_SIGNIFICANCE_THERAPEUTIC']) { this.therapeuticFormName = this.editorFormsMap['CLINICAL_SIGNIFICANCE_THERAPEUTIC'].name; }
    if (this.editorFormsMap['CASES']) { this.casesFormName = this.editorFormsMap['CASES'].name; }
    if (this.editorFormsMap['CLINICAL_TRIALS']) { this.clinicalTrialsFormName = this.editorFormsMap['CLINICAL_TRIALS'].name; }
    if (this.editorFormsMap['SUMMARY']) { this.summaryFormName = this.editorFormsMap['SUMMARY'].name; }
    if (this.editorFormsMap['PUBMED']) { this.pubmedFormName = this.editorFormsMap['PUBMED'][this.curationItem.aberration.AberrationClass].name; }
  }

  prepareDataToSave(status: string): Promise<boolean> {
    // add aberration key to curationData
    if (!this.curationItem.curationData['manualAnnotations']) {
      this.curationItem.curationData['manualAnnotations'] = { };
    }

    // add tier to curationData
    this.curationItem.curationData['tier'] = CurationEditorHelper.calculateTierFromCuration(this.curationItem.curationData['noClinicalSignificancePublications'], this.curationItem.curationData['clinicalSignificances']);
    this.removeTempParameters();
    return Promise.resolve(true);
   }

   postGetCurationItem() { }

  updateSpecificRefrences() {
    this.evidence = new CurationEvidenceBuilder()
      .setDiagnosticMaxEvidLevel(_.get(this.curationItem.curationData['metadata'], 'diagnosticMaxEvidLevel'))
      .setprognosticMaxEvidLevel(_.get(this.curationItem, 'curationData.metadata.prognosticMaxEvidLevel'))
      .setTherapeuticMaxEvidLevel(_.get(this.curationItem, 'curationData.metadata.therapeuticMaxEvidLevel'))
      .setTier(this.curationItem.curationData['tier'])
      .getEvidence();
  }

  private removeTempParameters() {
    // looking for new created items before saving the data and delete the NEW_ITEM temp key
    if (this.curationItem.curationData[CurationEditorHelper.CASES_ROOT]) {
      for (const item of this.curationItem.curationData[CurationEditorHelper.CASES_ROOT]) {
        if (item[CurationEditorHelper.INTERNAL_NEW_ITEM_PARAM_NAME]) {
          delete item[CurationEditorHelper.INTERNAL_NEW_ITEM_PARAM_NAME];
        }
      }
    }

    if (this.curationItem.curationData[CurationEditorHelper.CLINICAL_SIG_ROOT]) {
      for (const item of this.curationItem.curationData[CurationEditorHelper.CLINICAL_SIG_ROOT]) {
        if (item[CurationEditorHelper.INTERNAL_NEW_ITEM_PARAM_NAME]) {
          delete item[CurationEditorHelper.INTERNAL_NEW_ITEM_PARAM_NAME];
        }

        if (item.pubmedLinks) {
          item['pubmedLinks'] = CurationUtils.removeUndefinedPubmed(item.pubmedLinks);
        }
      }
    }

    if (this.curationItem.curationData[CurationEditorHelper.CLINICAL_TRIALS_ROOT]) {
      for (const item of this.curationItem.curationData[CurationEditorHelper.CLINICAL_TRIALS_ROOT]) {
        if (item[CurationEditorHelper.INTERNAL_NEW_ITEM_PARAM_NAME]) {
          delete item[CurationEditorHelper.INTERNAL_NEW_ITEM_PARAM_NAME];
        }
      }
    }

    // remove from pubmeds undefined links
    if (this.curationItem.curationData['manualAnnotations'].pubmedsLinks) {
      this.curationItem.curationData['manualAnnotations'].pubmedsLinks = CurationUtils.removeUndefinedPubmed(this.curationItem.curationData['manualAnnotations'].pubmedsLinks);
    }
  }

  getCurationKey(): string {
    return this.curationItem.metadata && this.curationItem.metadata['aberrationKey'];
  }

  getDataAndConfiguration(curationId: string) {
    let type: string = this.curationType;
    this.curationActionCreatorService.getState(['definitions'])
      .take(1)
      .subscribe((data => {
        this.conf = Array.from(data.values()).filter(data => data['type'] === this.curationType)[0];
        this.editorFormsMap = this.conf['ui']['forms']['editorForms'];
        this.curationActionCreatorService.getCurationItem(curationId, this.currentRevisionId).subscribe(res => {
          if (res && res.annotations && res.annotations[0] && res.annotations[0].annotations) {
            if (!res.curationData.hasOwnProperty('manualAnnotations')) {
              res.curationData['manualAnnotations'] = { };
            }

            res.annotations[0].annotations.filter(function (data) {
              if (data.value) {
                switch (data.name) {
                  case 'ncbi_summary':
                    if (!res.curationData['manualAnnotations'].hasOwnProperty('geneNarrative')) {
                      res.curationData['manualAnnotations']['geneNarrative'] = data.value;
                    }
                    break;
                  case 'gene_name1_ncbi_summary':
                    if (!res.curationData['manualAnnotations'].hasOwnProperty('geneNarrative1')) {
                      res.curationData['manualAnnotations']['geneNarrative1'] = data.value;
                    }
                    break;
                  case 'gene_name2_ncbi_summary':
                    if (!res.curationData['manualAnnotations'].hasOwnProperty('geneNarrative2')) {
                      res.curationData['manualAnnotations']['geneNarrative2'] = data.value;
                    }
                    break;
                }
              }
            });
          }

          this.curationItem = res;
          this.oldCurationItem = JSON.parse(JSON.stringify(res));
          this.curationStatus = this.curationItem.opinion['to']; // Status is saved in 'to' field of opinion
          this.curationId = this.curationItem.id;
          this.currentRevisionId = res.currentWorkflowRequestRevision;
          this.curationKey = this.getCurationKey();
          this.oldRevisionIsShown = this.curationItem.currentWorkflowRequestRevision != this.curationItem.workflowRequestActiveRevision;
          this.approvedMode = this.curationStatus == CurationSettings.CURATION_STATUS_APPROVED;
          this.setUserModes();
          this.loadFormNames();
          this.aberrationDetailsFormName = this.editorFormsMap[this.curationItem.metadata['aberrationSubClass']].name;

          if (this.editorFormsMap[this.curationItem.metadata['aberrationSubClass']]['vertical'] != null) {
            this.aberrationDataVerticalForm = this.editorFormsMap[this.curationItem.metadata['aberrationSubClass']]['vertical'];
          }

          // Update external search parameters after aberration type was set
          this.searchGeneralConfigParams = this.curationActionCreatorService.getCurationSearchConfigParams();

          if (this.searchGeneralConfigParams) {
            this.searchFormConfigParams = this.searchGeneralConfigParams['searchForm'];
            this.searchDataConfigParams = this.searchGeneralConfigParams[SEARCH_DATA_PREFIX + this.aberrationDetailsFormName];
            this.googleSearchURL = this.searchGeneralConfigParams['googleSearchURL'];
            this.pubmedSearchURL = this.searchGeneralConfigParams['pubmedSearchURL'];
          }

          this.curationDataForSearch = CurationUtils.getFlatAberrationData(this.curationItem);

          this.evidence = new CurationEvidenceBuilder()
            .setDiagnosticMaxEvidLevel(_.get(this.curationItem.curationData['metadata'], 'diagnosticMaxEvidLevel', ''))
            .setprognosticMaxEvidLevel(_.get(this.curationItem, 'curationData.metadata.prognosticMaxEvidLevel', ''))
            .setTherapeuticMaxEvidLevel(_.get(this.curationItem, 'curationData.metadata.therapeuticMaxEvidLevel', ''))
            .setTier(_.get(this.curationItem, 'curationData.metadata.tier', CurationEditorHelper.calculateTierFromCuration(this.curationItem.curationData['noClinicalSignificancePublications'], this.curationItem.curationData['clinicalSignificances'])))
            .getEvidence();

          this.curationActionCreatorService.getCurationRevisions(this.curationItem.workflowRequestId).subscribe(
            (data => {
                this.setupRevisionData(data);
                this.calculateState();
                this.isDataLoaded = true;
              }
            ));
        }
        );
      }));
  }

  private unique(value, index, self) {
    return self.indexOf(value) === index;
  }

  updateCurationItem(status: string, data: ICurationUpdateRequest) {
		//Pubmed links must be unique
    if (this.curationItem.curationData['manualAnnotations'].pubmedsLinks){
      const links = this.curationItem.curationData['manualAnnotations'].pubmedsLinks.map(link => link.pubmedlink);
      const uniqueLinks = links.filter(this.unique)
      if (links.length != uniqueLinks.length){
				this.notificationMessageService.error('Cannot save changes: Same Pubmed link exists more than once. Please update the links.');
				return;
      }
		}

    // Adding disease structure to align with newer update function (same as in Patway)
    if (data.curationData) { // curationData is removed in approved curations
      data.curationData['disease'] = { };
      data.curationData['disease']['code'] = this.curationItem.disease;
      data.curationData['disease']['display'] = this.curationItem.diseaseDisplay;
    }

    this.curationActionCreatorService.updateCurationItem(this.curationItem.id, data).subscribe(res => {
      if (res['status'] && res['status'] == CurationEditorHelper.ERROR_NOT_LATEST_REVISION) {
        this.notificationMessageService.error('Cannot save changes: Curation was updated by another user');
      }
      else if (res['error']) {
        this.notificationMessageService.error('Cannot save changes: ' + res['error']);
        console.error('changeStatus Error: ' + res['error'] + ', details: ' + res['details']);
      }
      else {
        if (status != CurationSettings.CURATION_STATUS_DRAFT) {
          this.goBack();
        }
        else {
          this.currentRevisionId = res.currentWorkflowRequestRevision;
          this.curationActionCreatorService.getCurationRevisions(this.curationItem.workflowRequestId).subscribe(
            (data => {
                this.setupRevisionData(data);
                // order of updated fields is important for angular trigers for depend components
                this.curationItem = res;
                this.oldCurationItem = JSON.parse(JSON.stringify(res));
                this.curationStatus = status;
                this.updateSpecificRefrences();
                this.calculateState();
                this.submitted = false; // in order to prevent fields highlight to be saved in case user didn't click on save
              }
            ));
        }
      }
    });
  }

  itemValidationEvent($event) {
    this.validationFormsMap.set($event.elementKey , $event.validationStatus);
    this.calculateValidationState();
  }

  setRevisionTag() {
    if (this.curationItem) {
      if (this.curationItem['id'] && this._revisionCount > 0) {
        this.revisionTag = this.curationItem['id'] + '__' + this._revisionCount.toString();
      }
    }
  }

  deleteItem($event) {
    // remove deleted element from validation
    this.validationFormsMap.delete($event.key);
    this.calculateValidationState();
  }

  private calculateValidationState() {
    let valid: boolean = true;
    this.validationFormsMap.forEach((value: boolean, key: string) => {
      if (value == false) {
        valid = false;
      }
    });
    this.isValid = valid;
    this.calculateState();
  }

  aberrationDataChangedEvent($event) {
    this.curationDataForSearch = CurationUtils.getFlatAberrationData(this.curationItem);
  }
}
